import React from 'react';
import { Link } from 'react-router-dom';
import { motion, useReducedMotion } from 'framer-motion';
import { images } from '../../data/images';
const ease = [0.23, 1, 0.32, 1] as const;
export function HomeHero() {
  const reduce = useReducedMotion();
  return <section className="relative w-full overflow-hidden bg-berry" data-id="element-84" data-mp="247snlp7rux69">
      <img src={images.hero} alt="Traditionele Marokkaanse hammam met zellige-tegels, savon beldi, kessa, ghassoul en arganolie" className="absolute inset-0 h-full w-full object-cover object-[70%_50%]" data-id="element-85" data-mp="295c46vrxzm1d" />
      <div className="absolute inset-0 bg-berry/45 lg:bg-berry/30" aria-hidden="true" data-id="element-86" data-mp="31v11oz5g13y8" />

      <div className="relative mx-auto flex min-h-[560px] max-w-7xl items-end px-5 pb-14 pt-24 lg:min-h-[calc(100svh-10.25rem)] lg:items-center lg:px-8 lg:pb-20" data-id="element-87" data-mp="2n27m7dq68ntk">
        <div className="max-w-xl text-white" data-id="element-88" data-mp="3fry1hq3jhvr9">
          <h1 className="font-display text-[clamp(3.25rem,7.5vw,7rem)] uppercase leading-[0.9] tracking-display" data-id="element-89" data-mp="3fr66agduu01i">
            {['Puur uit', 'Marokko.'].map((l, i) => <span key={l} className="block overflow-hidden pb-[0.04em]" data-id="element-90" data-mp="ovqwqrrtxube" data-mpi={i}>
                <motion.span className="block" initial={reduce ? false : {
              y: '105%'
            }} animate={{
              y: 0
            }} transition={{
              duration: 0.3,
              delay: 0.1 + i * 0.07,
              ease
            }} data-id="element-91" data-mp="jx75qcydpsc6">
                  {l}
                </motion.span>
              </span>)}
          </h1>
          <motion.div initial={reduce ? false : {
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          delay: 0.28,
          ease
        }} data-id="element-92" data-mp="12mm582yf29eg">
            <p className="mt-6 max-w-md text-lg font-light leading-relaxed text-white/85" data-id="element-93" data-mp="1cktj2cxesbc8">
              Savon Beldi, ghassoul en arganolie — de verzorging van de hammam, zoals Amira het van haar oma leerde in Aït Baha.
            </p>
            <div className="mt-9 flex flex-wrap gap-3" data-id="element-94" data-mp="3ed81re7s1jtp">
              <Link to="/collectie/bestsellers" className="inline-flex h-14 items-center whitespace-nowrap bg-white px-8 text-sm font-semibold uppercase tracking-[0.14em] text-berry transition-colors duration-150 hover:bg-pink hover:text-white" data-id="element-95" data-mp="1hbk0hc5p9qv7">
                Shop bestsellers
              </Link>
              <Link to="/over-amira#ritueel" className="inline-flex h-14 items-center whitespace-nowrap border border-white px-8 text-sm font-semibold uppercase tracking-[0.14em] text-white transition-colors duration-150 hover:bg-white hover:text-berry" data-id="element-96" data-mp="1w9ulzsnpo7ui">
                Ontdek het ritueel
              </Link>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}